export default "__VITE_ASSET__Dtc3q6je__"